import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { LogonResponse } from 'src/app/models/logon-response.model'

@Injectable({
  providedIn: 'root',
})
export class LogonService {
  constructor(private readonly http: HttpClient) {}

  public static readonly logonServiceEndpoint = '/rps/logon'
  getLoggedOn(): Promise<LogonResponse> {
    return this.http
      .get<LogonResponse>(LogonService.logonServiceEndpoint)
      .toPromise()
  }
}

